export default function comparisonTable() {
	document.querySelectorAll('.comparison-table__table').forEach((table) => {
		// One listener per table: a click anywhere on an expandable row toggles
		// it, and the button inside the label cell keeps it keyboard operable.
		table.addEventListener('click', (event) => {
			const row = event.target.closest('.comparison-table__row--expandable');
			if (!row) {
				return;
			}

			const toggle = row.querySelector('.comparison-table__toggle');
			const description = toggle
				? document.getElementById(toggle.getAttribute('aria-controls'))
				: null;
			if (!description) {
				return;
			}

			const expanded = toggle.getAttribute('aria-expanded') === 'true';
			toggle.setAttribute('aria-expanded', String(!expanded));
			description.hidden = expanded;
		});
	});
}
comparisonTable();
